import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@backoffice-frontend/shared/directives/common';
import type { SettingSpotConfigurationIdentifier } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { indicate } from '@clean-code/shared/common';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import {
  TableStateService,
  UiMatTableModule,
} from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { KatexPipe } from '@clean-code/shared/pipes/ui-katext';
import { TranslocoModule } from '@jsverse/transloco';
import { combineLatest, map, startWith, switchMap, takeUntil } from 'rxjs';
import { SettingSpotConfigurationIdentifierService } from '../../services/setting-spot-configuration-identifier.service';
@Component({
    templateUrl: './setting-spot-configuration-identifier-list.component.html',
    imports: [
        CommonModule,
        RouterModule,
        TranslocoModule,
        MatCheckboxModule,
        DirectivesModule,
        PageContainerModule,
        ActionButtonModule,
        UiMatTableModule,
        KatexPipe,
    ],
    providers: [TableStateService]
})
export class SettingSpotConfigurationIdentifierListComponent extends DataTableBaseComponent<SettingSpotConfigurationIdentifier> {
  settingSpotConfigurationIdentifierService: SettingSpotConfigurationIdentifierService;

  public spotId$ = this.activatedRoute.paramMap.pipe(
    map((params) => params.get('idSpot').toString()),
  );

  protected override navigateUrl: string;
  public energySource$ = this.activatedRoute.paramMap.pipe(
    map((params) => params.get('energySource')?.toUpperCase()),
  );

  public country$ = this.activatedRoute.paramMap.pipe(
    map((params) => params.get('country')),
  );

  public stockMarket$ = this.activatedRoute.paramMap.pipe(
    map((params) => params.get('stockMarket')),
  );

  public url$ = combineLatest([
    this.spotId$,
    this.energySource$,
    this.country$,
    this.stockMarket$,
  ]).pipe(
    map(
      ([spotId, energySource, country, stockMarket]: [
        ID,
        string,
        string,
        string,
      ]) =>
        (this.navigateUrl = `spotConfigurationIdentifier/${spotId}/${energySource}/${country}/${stockMarket}`),
    ),
    takeUntil(this.closeSubject),
  );

  public spotIdentifiers$ = combineLatest([
    this.spotId$,
    this.tableStateService.refreshTrigger$.pipe(startWith(null)),
  ]).pipe(
    map(([id, _]: [ID, any]) => id),
    switchMap((id: ID) =>
      this.settingSpotConfigurationIdentifierService
        .getAllSettingSpotConfigurationIdentifier$(id)
        .pipe(indicate(this.isLoading$)),
    ),
  );

  constructor() {
    const settingSpotConfigurationIdentifierService = inject(
      SettingSpotConfigurationIdentifierService,
    );

    super(settingSpotConfigurationIdentifierService);

    this.settingSpotConfigurationIdentifierService =
      settingSpotConfigurationIdentifierService;

    this.url$.subscribe();
  }
}
